/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_Addmember1Inputs */

const en_cases_settings_category_addmember1 = /** @type {(inputs: Cases_Settings_Category_Addmember1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add case managers`)
};

/**
* | output |
* | --- |
* | "Add case managers" |
*
* @param {Cases_Settings_Category_Addmember1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_addmember1 = /** @type {((inputs?: Cases_Settings_Category_Addmember1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Addmember1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_addmember1(inputs)
});
export { cases_settings_category_addmember1 as "cases_settings_category_addMember" }